import * as React from 'react';
import { createRendererWithUniDriver } from '../../test/utils';
import { datePickerInputOldDriverFactory } from './DatePickerInputOld.driver';
import { DatePickerInputOld } from '.';

describe('DatePickerInput', () => {
  const createDriver = createRendererWithUniDriver(
    datePickerInputOldDriverFactory,
  );
  const noop = () => {};

  it('should render', async () => {
    const { driver } = createDriver(
      <DatePickerInputOld value={new Date()} onChange={() => {}} />,
    );
    expect(await driver.exists()).toBe(true);
    expect(await driver.isLabelExists()).toBe(false);
  });

  it('should render label', async () => {
    const { driver } = createDriver(
      <DatePickerInputOld
        value={new Date()}
        onChange={noop}
        label="Start Date"
      />,
    );
    expect(await driver.isLabelExists()).toBe(true);
    expect(await driver.getLabelText()).toBe('Start Date');
  });

  describe('aria-expanded attribute', () => {
    it('should have aria-expanded set to false by default', async () => {
      const { driver } = createDriver(
        <DatePickerInputOld value={new Date()} onChange={noop} />,
      );
      expect(await driver.isCalendarOpen()).toBe(false);
    });

    it('should have aria-expanded set to true when calendar is opened', async () => {
      const { driver } = createDriver(
        <DatePickerInputOld value={new Date()} onChange={noop} />,
      );
      await driver.openCalendarWindow();
      expect(await driver.isCalendarOpen()).toBe(true);
    });
  });
});
